<template>
    <div v-if="visible">
        <v-dialog
            v-model="dialog"
            persistent
            max-width="500"
        >
            <v-card>
                <v-card-title class="px-3">Change Card</v-card-title>
                <v-divider></v-divider>

                <v-container fluid>
                    <v-row>
                        <v-col md="12" class="pb-0" align="center" justify="center">
                            <!-- Product -->
                            <v-select
                                v-model="newCard"
                                :items="activeCards"
                                dense
                                return-object
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-container>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="$emit('close', false)">Close</v-btn>
                    <v-btn color="primary" @click="changeCard">Change Card</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        visible: Boolean,
        cards: Array,
        curCard: Object
    },
    computed: {
        dialog() {
            return this.visible ? true : false;
        },
        activeCards() {
            let active = [];
            this.cards.filter(e => {
                if(e.state === 'active') {
                    active.push({ text: `${e.card.bin}******${e.card.last4Digits} - ${e.card.paymentBrand} - ${e.card.holder}`,
                                  value: e.card.id,
                                  cardData: e.card });

                    if(e.card.id == this.curCard.registrationId) {
                        this.newCard = { text: `${e.card.bin}******${e.card.last4Digits} - ${e.card.paymentBrand} - ${e.card.holder}`,
                                         value: e.card.id,
                                         cardData: e.card };
                    }
                }
            });
            return active;
        }
    },
    data() {
        return {
            newCard: null
        }
    },
    methods: {
        changeCard() {
            axios({
                method: 'post',
                url: 'change-card',
                data: { scheduleId: this.curCard.id,
                        registrationId: this.newCard.value,
                        clientId: this.curCard.clientId,
                        userId: this.$store.state.user.id,
                        bin: this.newCard.cardData.bin,
                        last4Digits: this.newCard.cardData.last4Digits },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.$emit('getSchedules');
                    this.$emit('getClientLog');
                })
                .catch(e => {
                    this.errors.push(e)
            })
        }
    }
}
</script>

<style>
 
</style>